import { Component, OnInit } from '@angular/core';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { NgForm } from '@angular/forms';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-item-servico-inserir',
  templateUrl: './item-servico-inserir.component.html',
  styleUrls: ['./item-servico-inserir.component.scss']
})
export class ItemServicoInserirComponent extends AdmihairBaseComponent implements OnInit {

  subgrupos: SelectItem[] = [];
  planoContaEmpresa?: PlanoContaEmpresa;
  agendaChecked: boolean = false;
  valorMedio: number = 0;
  tempoMedioFormatado: string = '00:00';
  codigoExistente: boolean = false;
  listaAgenda: any[] = [
    {
      descricao: 'SIM',
      valor: 'SIM'
    },
    {
      descricao: 'NÃO',
      valor: 'NAO'
    },
    {
      descricao: 'EXCLUSIVO',
      valor: 'EXCLUSIVO'
    }
  ];

  progressoRequisicao: boolean = false;
  horasServico: string[] = ['00', '01', '02', '03', '04', '05', '06'];
  minutosServico: string[] = ['00', '05', '10', '15', '20', '25', '30',
    '35', '40', '45', '50', '55'];

  exibirDialogValorSugerido: boolean = false;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  loadingSpinnerDialog: boolean = false;
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValorServico: number = 0;
  valorLucroObtidoAtual: number = 0;

  itemServico: ItemServico = {
    custoMaterial: 0,
    comissaoVenda: 0,
    valorVenda: 0,
    tributacao: false,
    tempoMedioHora: '00',
    tempoMedioMinuto: '00'
  };

  constructor(private itemServicoService: ItemServicoService,
    private custoService: CustoService,
    private subgrupoService: SubgrupoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_SERVICO');
    this.buscarSubgrupos();
    this.buscarPlanoContaEmpresa();
  }

  salvar(form: NgForm) {
    this.progressoRequisicao = true;


    this.itemServico.empresa = this.getEmpresa();
    if (this.planoContaEmpresa) {
      this.itemServico.planoContaEmpresa = this.planoContaEmpresa;
    }
    this.itemServico.ativo = true;
    this.itemServico.descricaoUnidadeMedida = 'UN';
    this.itemServico.quantidadeUnidadeMedida = 1;
    this.itemServico.estoqueAtual = 1;
    this.itemServico.custoMaterial = this.itemServico.custoMaterial || 0;
    this.itemServico.comissaoVenda = this.itemServico.comissaoVenda || 0;
    this.itemServico.valorVenda = this.itemServico.valorVenda || 0;
    this.itemServico.tempoMedio = this.itemServico.tempoMedio || '00:00';
    this.itemServico.tributacao = this.itemServico.tributacao || false;
    this.itemServico.controlaEstoque = true;
    this.itemServico.descricao = FormatacaoUtil.removerCaracteresEspeciais(this.itemServico.descricao);

    this.itemServicoService.salvarItemServico(this.itemServico).subscribe({
      next: (data: ItemServico) => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        form.reset();
        this.redefinirValoresItemServico();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  redefinirValoresItemServico() {
    this.itemServico = {
      custoMaterial: 0,
      comissaoVenda: 0,
      valorVenda: 0,
      tributacao: false
    };
  }

  buscarPlanoContaEmpresa() {
    const codigoContaServico = 4;
    this.planoContaEmpresaService
      .buscarPorEmpresaECodigo(this.getEmpresa().id, codigoContaServico)
      .subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.planoContaEmpresa = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
  }

  verificarCodigoExistente(valor: string) {
    if (valor) {
      this.itemServicoService.codigoExistentePorEmpresa(this.getEmpresa().id, valor).subscribe({
        next: (data: any) => {
          this.codigoExistente = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
    } else {
      this.codigoExistente = false;
    }
  }

  buscarSubgrupos() {
    this.subgrupoService.listarSubgruposServicoPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Subgrupo[]) => {
        this.subgrupos = data.map(item => (
          { label: `${item.grupo?.descricao} - ${item.descricao}`, value: item }
        ));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }


  abrirDialogValorSugerido() {
    this.loadingSpinnerDialog = true;
    this.novoValorServico = 0;
    this.valorLucroDesejado = 0;
    this.valorLucroObtido = 0;
    this.valorSugerido = 0;
    this.exibirDialogValorSugerido = true;
    this.obterCustos();
  }

  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.calcularLucroObtidoAtual();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirDialogValorSugerido = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  calcularLucroDesejado(event: any) {
    this.valorLucroDesejado = event.value ?? 0;
    if (this.valorLucroDesejado > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const sugestao = ((this.valorLucroDesejado * somaPercentuais) / ((somaPercentuais - 100) * -1)) + this.valorLucroDesejado;
      this.valorSugerido = sugestao;
    } else {
      this.valorSugerido = 0;
    }
  }

  calcularLucroObtido(valor?: number) {
    this.novoValorServico = valor ?? 0;
    if (this.novoValorServico > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.novoValorServico;
      if (this.novoValorServico) {
        this.valorLucroObtido = Number((this.novoValorServico - valorCustosTotais).toFixed(2));
      }
    } else {
      this.valorLucroObtido = 0;
    }

  }

  calcularLucroObtidoAtual() {
    if (this.itemServico
      && this.itemServico.valorVenda
      && this.itemServico.valorVenda > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.itemServico.valorVenda;
      this.valorLucroObtidoAtual = Number((this.itemServico.valorVenda - valorCustosTotais).toFixed(2));
    } else {
      this.valorLucroObtidoAtual = 0;
    }
  }

  confirmarValorServico() {
    if (this.itemServico) {
      this.itemServico.valorVenda = this.novoValorServico;
    }
    this.exibirDialogValorSugerido = false;
  }

}
